import React, { useState, useEffect, useRef } from 'react';
import useNetwork from '../useNetwork';
import useInfiniteScroll from "../useInfiniteScroll";
import { AuctionTile } from './auction/AuctionTile';
import { VLink } from "./AppDataContext"
import { Helmet } from "react-helmet";



export function Director(props) {
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const [director, setDirector] = useState(null);
	const [auctions, setAuctions] = useState(null);
	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(getAuctions);

	const startIx = useRef(0);
	const auctionSessionCount = useRef(0);
	// use a page size that show well with 3 as well as 2
	const pageSize = 12;

	function getDirector() {
		const fetchDirector = async () => {
			const url = 'api/site/getdirector/' + props.match.params.directorId;

			const response = await netRequest(url);

			if (response.data != null) {
				setDirector(response.data);
			}
		}
		fetchDirector();
	}

	// this useEffect has [] as the parms, so only gets call on didMount
	useEffect(() => {
		getDirector();
	}, []);

	function getAuctions(startAtBeginning) {

		const fetchAuctions = async (startingAt) => {
			if (startingAt == 0 || startIx.current < auctionSessionCount.current) {
				const url = 'api/site/getauctions/' + startingAt + '/' + pageSize + "/" + props.tab + '/' + props.match.params.directorId;

				const response = await netRequest(url);

				if (response.data != null) {
					if (startingAt == 0)
						setAuctions(response.data.auctionSessions);
					else
						setAuctions([...auctions, ...response.data.auctionSessions]);
					// set our next starting point
					startIx.current = startingAt + pageSize;

					auctionSessionCount.current = response.data.auctionSessionCount;
					console.log("Total Count: " + auctionSessionCount.current);
					const isEndReached = startIx.current >= auctionSessionCount.current;
					if (isEndReached === true)
						console.log("End of Auction reached");
					setIsDone(isEndReached);
				}
			}
			setIsFetching(false);
		};

		if (startAtBeginning) {
			startIx.current = 0;
			setIsDone(false);
		}

		fetchAuctions(startIx.current);
	}

	useEffect(() => {

		if (props.tab) {
			setAuctions(null);
			getAuctions(true);
		}
	}, [props.tab]);

	if (director == null) {
		return (
			<></>
		);
	}

    return (
		<main>
			<Helmet>
				<title>About {director.firstName} {director.lastName}</title>
			</Helmet>
			<section class="p-3 p-md-5">
				<div class="container">
					<div class="row">
						<div class="col-12 mb-3">
							<div class="d-flex justify-content-start mb-3">
								<VLink to={"/Seller/" + director.sellerCompany.secureId + "/directors"} className="lot-navigation lot-navigation__prev">Back to Seller Page</VLink>
							</div>
						</div>
						<div class="col-12 col-md-6 mb-5 about--seller">
							<div class="w-100">
								<h1 class="d-inline display-6 me-3">About {director.firstName} {director.lastName}</h1>
							</div>
							<div class="divider mb-3"></div>
							<p><img src={"/api/site/auctionmanagerphoto/" + director.secureId + "/100"} alt="Image" title="Title" class="float-start me-3 mb-3" />{director.sellerCompany.description}</p>
						</div>
						<div class="col-12 col-md-6 mb-5">
							<h1 class="display-6">Contact Details</h1>
							<div class="divider mb-3"></div>
							<div class="d-flex align-items-center pickup__content py-2">
								<div class="d-inline me-3">
									<i class="bi bi-envelope"></i>
								</div>
								<div class="d-inline">
									<h4 class="mb-0 pb-0" >Email</h4>
									<h5 class="mb-0 pb-0"><a href={"mailto:" + director.email} >{director.email}</a></h5>
								</div>
							</div>
							<div class="d-flex align-items-center pickup__content py-2">
								<div class="d-inline me-3">
									<i class="bi bi-phone"></i>
								</div>
								<div class="d-inline">
									<h4 class="mb-0 pb-0" >Phone</h4>
									<h5 class="mb-0 pb-0">{director.phone}</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="background-color">
				<div class="container">
					<div class="row">
						<div class="col-12">
							{ /* Nav tabs */ }
							<ul class="nav nav-tabs nav-justified nav-tabs-adjusted">
								<li class="nav-item">
									<VLink to={"/director/" + props.match.params.directorId} class={"nav-link " + (props.tab == "directorCurrent" ? "active" : "")}  >{director.firstName}'s Auctions</VLink>
								</li>
								<li class="nav-item">
									<VLink to={"/director/" + props.match.params.directorId + "/past"} class={"nav-link " + (props.tab == "directorPast" ? "active" : "")}  >{director.firstName}'s Past Auctions</VLink>
								</li>
							</ul>
							<div class="tab-content">
								<div class="tab-pane container h-100 py-3 px-0 active">
									{auctions ?
										<div class="row">
											{auctions.length > 0 ?
												auctions.map((a) => <AuctionTile key={a.secureId} auction={a} showSeller={false} />)
												:
												props.tab == "directorCurrent" ?
													<>No Current Auctions</>
													:
													<>No Past Auctions</>
											}
											{isFetching && !isDone && <div>Fetching More...</div>}
											{(auctionSessionCount.current > 0 && isDone) && <div class="col-12"><p class="text-center end-of-auction">End of {props.tab == "directorCurrent" ? "Current" : "Past"} Auctions</p></div>}
										</div>
										:
										<div class="row">
											Fetching Auctions...
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>


    );

}